import React from "react";
import { Container, Row, Col } from "reactstrap";
import Card from "reactstrap/lib/Card";

function TextGrid() {
  let pageHeader = React.createRef();
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      <div
        style={{
          backgroundColor: "#fff",
          background: `url(${require("assets/images/landscape.webp")})`,
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          backgroundSize: "cover",
          paddingTop: "8rem",
          overflow: "hidden",
        }}
        className="section pt-5"
        data-parallax={true}
        ref={pageHeader}
      >
        <div className="overlay-primary"></div>
        <Container>
          <Row className="justify-content-center">
            <Col md={9}>
              <h1
                className="m-0 my-4 text-g-p text-white"
                style={{
                  fontSize: size ? "3rem" : "2rem",
                }}
              >
                Event
                <br />
                Summary
              </h1>
              <p className="text-400 text-white">
                Following the success of the{" "}
                <b>2023 and 2024 editions in London, UK DIGITAL TWIN 2025</b>
                marks the third Annual gathering of digital leaders, visionaries, and innovators
                across the Smart Cities, Urban Planning and Built Environment sector.
                <br />
                <br />
                This year, the conference moves to Nottingham, a city rapidly emerging as a national
                leader in digital innovation. With strong backing from Nottingham City Council and
                ongoing research excellence from the University of Nottingham, the 2025 edition will
                spotlight the city’s pioneering work in applying Digital Twins for urban planning,
                infrastructure management, and sustainability.
                <br />
                <br />
                Continuing under the theme <b>“From Vision to Reality,”</b> the two-day event will
                offer a strategic platform to:
                <ul>
                  <li>Explore the UK Government’s evolving roadmap for Digital Twins</li>
                  <li>
                    Learn from regional and global case studies, pilot projects, and proven
                    deployments
                  </li>
                  <li>Engage with local authority leaders, academia, and industry experts</li>
                  <li>
                    Discover cutting-edge technologies shaping the future of smart cities and the
                    built environment.
                  </li>
                </ul>
                <br />
                The conference on <b>November 11</b> promises an exhaustive agenda of Keynotes,
                panels, and technical sessions featuring central and local government, universities,
                and industry pioneers. <b>November 12</b> will have In-depth workshops offering
                hands-on technical knowledge and real-world implementation strategies for Digital
                Twin applications in the Built Environment, Energy, and Urban Innovation sectors,
                alongside a Seminar run by the{" "}
                <b>Association for Geographical Information (AGI) 3D Network Event.</b>
                <br />
                <br />
                <b>
                  Join us in Nottingham to explore how Digital Twins are moving from concept to
                  impact—enabling smarter, more sustainable, and resilient cities across the UK and
                  beyond.
                </b>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default TextGrid;
